/*
 * grids-to-graphs
 *
 * Loop through all tables in
 * any node to add a graph
 * widget for each one.
 *
 * Author: Tim Bauwens
 * Copyright 2017 Berkeley Bridge
 *
 * NB Dependencies: >= v4.4 Studio/Server
 */

(function ($, win, doc) {
  $(doc).on("bb:postHandleData", function (event, data) {
    /*
    Example JSON for technical meta data:

{"graphSettings" : {
    "directives" : {
      "main.small_grid.gridvar" : {
        "colorOverrides" : {
          "A-team" : "blue",
          "B-team" : "rgb(155,10,10)",
          "APAC" : "darkblue",
          "EMEA" : "darkgreen",
          "Apples" : "#14C44C",
          "Oranges": "orange",
          "Strawberries" : "#ED1564",
          "Aubergines": "purple"
        },
        "colorArray" : [
          "#075285",
          "#11649C",
          "#217AB5",
          "#2E85BF",
          "#469BD4",
          "#60ADE0",
          "#85C3ED",
          "#99CDF0",
          "#C3E4FA"
        ]
      },
      "main.large_grid.gridvar" : {
        "colorOverrides" : {
          "A-team" : "blue",
          "B-team" : "rgb(155,10,10)",
          "APAC" : "darkblue",
          "EMEA" : "darkgreen",
          "Apples" : "#14C44C",
          "Oranges": "orange",
          "Aubergines": "purple",
          "Strawberries" : "#ED1564"
        },
        "colorArray" : [
          "#075285",
          "#11649C",
          "#217AB5",
          "#2E85BF",
          "#469BD4",
          "#60ADE0",
          "#85C3ED",
          "#99CDF0",
          "#C3E4FA"
        ]
      }
    }
  }
}


*/

    if (data && data.groups) {
      var userDefined, serverinstructions, graphSettings, directives;
      try {
        serverinstructions = JSON.parse(atob(data.serverinstructions));
        graphSettings = serverinstructions.graphSettings || false;
        directives = graphSettings.directives || false;
        userDefined = directives ? true : false;
      } catch (e) {
        userDefined = false;
      }
      var colorMap = colorMap || {};
      var build = build || {
        currentGraph: "",
        getOptions: function ($widget, graphType) {
          // grab the current options states in widget, then return as obj.
          var optionSet = {};
          optionSet.width = $widget.width();
          if (graphType === "column") {
            optionSet.y = $widget
              .find(".column-chart-option select[data-y]")
              .find(":selected")
              .data("column");
            optionSet.x = $widget
              .find(".column-chart-option select[data-x]")
              .find(":selected")
              .data("column");
            optionSet.legend = $widget
              .find(".column-chart-option select[data-legend]")
              .find(":selected")
              .data("column");
          } else if (graphType === "stackedBar") {
            optionSet.y = $widget
              .find(".stacked-chart-option select[data-y]")
              .find(":selected")
              .data("column");
            optionSet.x = $widget
              .find(".stacked-chart-option select[data-x]")
              .find(":selected")
              .data("column");
            optionSet.legend = $widget
              .find(".stacked-chart-option select[data-legend]")
              .find(":selected")
              .data("column");
            optionSet.label = $widget
              .find(".stacked-chart-option select[data-label]")
              .find(":selected")
              .data("column");
          } else if (graphType === "pie") {
            optionSet.slices = $widget
              .find(".pie-chart-option select[data-slice]")
              .find(":selected")
              .data("column");
            optionSet.labels = $widget
              .find(".pie-chart-option select[data-label]")
              .find(":selected")
              .data("column");
            optionSet.additional = [];
            $widget
              .find('[data-additional] input[type="checkbox"]')
              .each(function () {
                if ($(this).is(":checked")) {
                  var column = $(this).attr("id");
                  optionSet.additional.push(column);
                }
              });
          }
          return optionSet;
        },
        bar: function (comp, $widget, optionSet) {
          // Reset Settings
          this.getReady(comp.gridIdentifier);
          // Generate a graph based on the selected axis.
          var textBlockSize = 13;
          var barMargin = 5; // Split on each side.
          var padding = {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50,
            horizontal: function () {
              return this.left + this.right;
            },
            vertical: function () {
              return this.top + this.bottom;
            }
          };
          //var yColumn = $widget.find('.column-chart-option select[data-y]');
          padding.left =
            padding.left >
            comp[optionSet.y].maxLength * (textBlockSize * 0.85) + 20
              ? padding.left
              : comp[optionSet.y].maxLength * (textBlockSize * 0.85) + 20;
          //var xColumn = $widget.find('.column-chart-option select[data-x]');
          //var legendColumn = $widget.find('.column-chart-option select[data-legend]');
          var hasLegend = optionSet.legend !== "none";
          if (hasLegend) {
            var legendMax =
              comp[optionSet.legend].maxLength >= 20
                ? 20
                : comp[optionSet.legend].maxLength;
            padding.right = legendMax * 8.6 + 50;
          }
          var minBarWidth = 15;
          var minWidth =
            (barMargin + minBarWidth) * comp.row +
            (padding.left + padding.right);
          var baseWidth =
            minWidth > optionSet.width ? minWidth : optionSet.width;
          var baseHeight = 400;
          var closeButtonOffset = 45;
          var additionalHeight = 0;
          if (hasLegend) {
            var uniqueLegendItems = 0;
            var currentItem = [];
            $.each(comp[optionSet.legend].vals, function (k, v) {
              if (currentItem.indexOf(v) === -1) uniqueLegendItems += 1;
              currentItem.push(v);
            });
            additionalHeight =
              uniqueLegendItems * textBlockSize > 300
                ? uniqueLegendItems * textBlockSize - 300
                : 0;
          }
          baseHeight = baseHeight + padding.vertical() + additionalHeight;
          var yAxisHeight = baseHeight - padding.vertical();
          var xAxisWidth = baseWidth - padding.horizontal();

          // Figure out y-axis.
          if (comp[optionSet.y].dataType === "number") {
            var min, max, delta, valueStep, axisStep;
            min = comp[optionSet.y].min;
            max = comp[optionSet.y].max;
            delta = max - min;
            if (min >= 0 && min < delta) {
              min = 0;
            } else {
              min = min - delta / 10;
            }
            delta = max - min;
            valueStep = delta / 10;
            axisStep = yAxisHeight / 10;
          }
          // Figure out x-axis.
          var barWidth, bars;
          bars = comp.row;
          barWidth = xAxisWidth / bars - barMargin;
          // Build basic axis, no data.
          var $svg = $(
            '\
            <svg \
              class="bb-p-graph-widget-bar-svg" \
              xmlns="http://www.w3.org/2000/svg" \
              data-visualizes="' +
              comp.gridIdentifier +
              '" \
              width="' +
              baseWidth +
              '" \
              height="' +
              baseHeight +
              '" \
              viewBox="0 0 ' +
              baseWidth +
              " " +
              baseHeight +
              '" \
              data-scale="1">\
                <defs>\
                  <filter id="glow" x="-10%" y="-10%" width="150%" height="150%">\
                    <feGaussianBlur stdDeviation="5 5" result="glow"/>\
                    <feMerge>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                    </feMerge>\
                  </filter>\
                </defs>\
            </svg>'
          )
            .append(
              '\
            <g class="break-out">\
              <a xlink:href="#" aria-label="Break graph out of page">\
                <rect \
                  x="0" \
                  y="0" \
                  fill="green" \
                  width="30" \
                  height="30">\
                </rect>\
              </a>\
              <text \
                x="5" \
                y="23">\
                  <tspan class="symbol">&#10529;</tspan>\
                  <title>Maximize</title>\
              </text>\
            </g>'
            )
            .append(
              '\
            <g class="close">\
              <a alt="close" xlink:href="#" aria-label="Delete this graph">\
                <rect \
                  x="' +
                (baseWidth - 30) +
                '" \
                  y="0" \
                  fill="red" \
                  width="30" \
                  height="30">\
                </rect>\
              </a>\
              <text \
                x="' +
                (baseWidth - 21) +
                '" \
                y="21">\
                  <tspan class="symbol">x</tspan>\
                  <title>Delete this graph</title>\
              </text>\
            </g>'
            )
            .append(
              '\
            <text \
              x="20" \
              y="' +
                baseHeight / 2 +
                '" \
              transform="rotate(-90 20 ' +
                baseHeight / 2 +
                ')" \
              class="title">\
                ' +
                this.stringParse(comp[optionSet.y].heading) +
                "\
            </text>"
            )
            .append(
              '\
            <text \
              x="' +
                baseWidth / 2 +
                '" \
              y="' +
                (baseHeight - padding.bottom / 2) +
                '" \
              class="title">\
                ' +
                this.stringParse(comp[optionSet.x].heading) +
                "\
            </text>"
            )
            .append(
              '\
            <line \
              x1="' +
                padding.left +
                '" \
              y1="' +
                (padding.top + yAxisHeight) +
                '" \
              x2="' +
                (baseWidth - padding.right) +
                '" \
              y2="' +
                (padding.top + yAxisHeight) +
                '" \
              class="guideline">\
            </line>'
            )
            .append(
              '\
            <line \
              x1="' +
                padding.left +
                '" \
              y1="' +
                (padding.top + yAxisHeight) +
                '" \
              x2="' +
                padding.left +
                '" \
              y2="' +
                padding.top +
                '" \
              class="guideline">\
            </line>'
            );
          // Add the y-axis range and gridlines.
          var i;
          for (i = 0; i <= 10; i++) {
            $svg
              .append(
                '\
              <text \
                x="' +
                  (padding.left - 10) +
                  '" \
                y="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '" \
                text-anchor="end">\
                  ' +
                  Math.round(min + valueStep * i) +
                  "\
              </text>"
              )
              .append(
                '\
              <line \
                class="gridline" \
                x1="' +
                  (padding.left - 5) +
                  '" \
                y1="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '" \
                x2="' +
                  (padding.left + xAxisWidth) +
                  '" \
                y2="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '">\
              </line>'
              );
          }
          // Add the bars.
          $svg.append(
            '\
            <g \
              id="bars" \
              transform="scale(1,-1) translate(' +
              (padding.left + barMargin / 2) +
              ",-" +
              (yAxisHeight + baseHeight) +
              ')">\
            </g>'
          );
          if (hasLegend) {
            $svg.append(
              '\
              <g \
                id="legend">\
                  <text \
                    x="' +
                (baseWidth - 5) +
                '" \
                    y="' +
                closeButtonOffset +
                '" \
                    text-anchor="end" \
                    class="title">\
                      ' +
                comp[optionSet.legend].heading +
                "\
                  </text>\
              </g>"
            );
          }
          for (i = 0; i < bars; i++) {
            var barValue = comp[optionSet.y].vals[i];
            var deltaV = barValue - min; // Delta between min range value, and barValue
            var vRatio = deltaV / delta; // How much space does the barValue take in the total value.
            var barHeight = yAxisHeight * vRatio; // How much space does barValue take in terms of the axis size.
            var barLabel = this.stringParse(comp[optionSet.x].vals[i]);
            var x = (barWidth + barMargin) * i;
            var legendLabel = !hasLegend
              ? false
              : comp[optionSet.legend].vals[i];
            var color = !hasLegend
              ? "rgb(0,150,200)"
              : build.generateColor.go(legendLabel, comp.gridIdentifier);
            $svg.children("g#bars").append(
              '\
              <rect \
                x="' +
                x +
                '" \
                y="' +
                (padding.bottom + yAxisHeight) +
                '" \
                width="' +
                barWidth +
                '" \
                height="' +
                barHeight +
                '" \
                stroke="none" \
                fill="' +
                color +
                '"\
                fill-opacity=".9" \
                highlight="true" \
                data-identifier="' +
                legendLabel +
                '">\
                  <animate attributeName="height" from="0" to="' +
                barHeight +
                '" dur="1s" fill="freeze" />\
              </rect>\
              <text \
                x="' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2) +
                '"\
                y="' +
                (-baseHeight + padding.top) +
                '"\
                filter="url(#glow)"\
                style="fill:#fff;"\
                transform="scale(1,-1) rotate(-90 ' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2) +
                " " +
                (-baseHeight + padding.top) +
                ')"> \
                  &nbsp;&nbsp;&nbsp;' +
                barLabel +
                '&nbsp;\
              </text>\
              <text \
                x="' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2) +
                '"\
                y="' +
                (-baseHeight + padding.top) +
                '"\
                class="label"\
                transform="scale(1,-1) rotate(-90 ' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2) +
                " " +
                (-baseHeight + padding.top) +
                ')"> \
                  &nbsp;&nbsp;&nbsp;' +
                barLabel +
                '&nbsp;\
              </text>\
              <text \
                x="' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2 - 5) +
                '"\
                y="' +
                (-(baseHeight + yAxisHeight) + padding.top / 2) +
                '"\
                class="label"\
                text-anchor="start"\
                transform="scale(1,-1) rotate(-30, ' +
                ((barWidth + barMargin) * i + (barWidth + barMargin) / 2 - 5) +
                ", " +
                (-(baseHeight + yAxisHeight) + padding.top / 2) +
                ')"> \
                  ' +
                barValue +
                '\
              </text>\
              <line \
                x1="' +
                ((barWidth + barMargin) * i + barWidth / 2) +
                '" \
                y1="' +
                (-(baseHeight + yAxisHeight) + padding.top / 2 + 14) +
                '" \
                x2="' +
                ((barWidth + barMargin) * i + barWidth / 2) +
                '" \
                y2="' +
                (-(baseHeight + yAxisHeight) +
                  padding.top +
                  (yAxisHeight - barHeight)) +
                '" \
                class="gridline dotted" \
                transform="scale(1,-1)" \
                stroke-dasharray="2, 5"> \
              </line>'
            );
            // Build the legend
            if (hasLegend) {
              var itemCount = $svg.find(
                'g#legend [data-type="legend-item"]'
              ).length;
              if (
                !$svg.find(
                  '[data-identifier="' +
                    legendLabel +
                    '"][data-type="legend-item"]'
                ).length
              )
                $svg
                  .children("g#legend")
                  .append(
                    '\
                  <rect \
                    x="' +
                      (baseWidth - textBlockSize - 5) +
                      '" \
                    y="' +
                      (itemCount +
                        closeButtonOffset +
                        itemCount * (textBlockSize + 2) +
                        5) +
                      '" \
                    width="' +
                      textBlockSize +
                      '" \
                    height="' +
                      textBlockSize +
                      '" \
                    fill="' +
                      color +
                      '" \
                    fill-opacity=".9" \
                    stroke="none" \
                    data-type="legend-item" \
                    highlight="true" \
                    data-identifier="' +
                      legendLabel +
                      '">\
                  </rect>'
                  )
                  .append(
                    '\
                  <text \
                    x="' +
                      (baseWidth - textBlockSize - 10) +
                      '" \
                    y="' +
                      (itemCount +
                        closeButtonOffset +
                        itemCount * (textBlockSize + 2) +
                        textBlockSize) +
                      '" \
                    text-anchor="end" \
                    class="legend-item" >\
                      ' +
                      this.stringParse(comp[optionSet.legend].vals[i]) +
                      "\
                  </text>"
                  );
            }
          }
          // Is there need for a zero line?
          if (min < 0 && max > 0) {
            $svg
              .children("g#bars")
              .append(
                '\
              <text \
                x="-' +
                  (barMargin / 2 + 40) +
                  '" \
                y="' +
                  (Math.abs(yAxisHeight * ((0 - min) / delta)) +
                    (padding.bottom + yAxisHeight) +
                    4) +
                  '"> \
                  0\
              </text>'
              )
              .append(
                '\
              <line \
                class="gridline zero" \
                x1="-' +
                  (barMargin / 2 + 30) +
                  '" \
                x2="' +
                  (xAxisWidth - barMargin / 2) +
                  '" \
                y1="' +
                  (Math.abs(yAxisHeight * ((0 - min) / delta)) +
                    (padding.bottom + yAxisHeight)) +
                  '" \
                y2="' +
                  (Math.abs(yAxisHeight * ((0 - min) / delta)) +
                    (padding.bottom + yAxisHeight)) +
                  '">\
              </line>'
              );
          }
          // Add the SVG and refresh the whole thing to show SVGs
          var svgID =
            $widget.attr("id") +
            Math.floor(Math.random() * 100000 + 1) +
            "-svg-container";
          $widget.append(
            '<div id="' + svgID + '" class="svg-container"></div>'
          );
          var $container = $("#" + svgID);
          var $scales = $(
            '<button class="svg-scale-down">-</button><button class="svg-scale-up">+</button>'
          );
          $container.append($scales);
          $container.append($svg);
          var pos = $svg.offset().top - 50;
          $container.html($container.html());
          // Scroll the page to show the graph
          var $parentContainer = $("#bb-q");
          setTimeout(function () {
            $parentContainer.animate(
              {
                scrollTop:
                  pos -
                  $parentContainer.offset().top +
                  $parentContainer.scrollTop()
              },
              300
            );
          }, 100);
          setTimeout(function () {
            $("html, body").animate(
              {
                scrollTop: pos
              },
              300
            );
          }, 100);
        },
        stackedBar: function (comp, $widget, optionSet) {
          // Reset Settings
          this.getReady(comp.gridIdentifier);
          // Generate a graph based on the selected axis.
          var textBlockSize = 13;
          var barMargin = 5; // Split on each side.
          //var margin = 50;
          var padding = {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50,
            horizontal: function () {
              return this.left + this.right;
            },
            vertical: function () {
              return this.top + this.bottom;
            }
          };
          padding.left =
            padding.left > comp[optionSet.y].maxLength * textBlockSize + 20
              ? padding.left
              : comp[optionSet.y].maxLength * textBlockSize + 20;
          var xMax =
            comp[optionSet.x].maxLength >= 20
              ? 20
              : comp[optionSet.x].maxLength;
          padding.left = padding.left > xMax * 5 ? padding.left : xMax * 5;
          padding.bottom =
            padding.bottom > xMax * 5 ? padding.bottom : xMax * 5;
          var hasLegend = optionSet.legend !== "none";
          if (hasLegend) {
            var legendMax =
              comp[optionSet.legend].maxLength >= 20
                ? 20
                : comp[optionSet.legend].maxLength;
            padding.right = legendMax * 6 + 50;
          }
          var minBarWidth = 15;
          var bars = [];
          $.each(comp[optionSet.x].vals, function (index, val) {
            if (bars.indexOf(val) === -1) {
              bars.push(val);
            }
          });
          var minWidth =
            (barMargin + minBarWidth) * bars.length + padding.horizontal();
          var baseWidth =
            minWidth > $widget.width() ? minWidth : $widget.width();
          var baseHeight = 400;
          var closeButtonOffset = 45;
          var additionalHeight = 0;
          if (hasLegend) {
            var uniqueLegendItems = 0;
            var currentItem = [];
            $.each(comp[optionSet.legend].vals, function (k, v) {
              if (currentItem.indexOf(v) === -1) uniqueLegendItems += 1;
              currentItem.push(v);
            });
            additionalHeight =
              uniqueLegendItems * textBlockSize > 300
                ? uniqueLegendItems * textBlockSize - 300
                : 0;
          }
          baseHeight = baseHeight + padding.vertical() + additionalHeight;
          var yAxisHeight = baseHeight - padding.vertical();
          var xAxisWidth = baseWidth - padding.horizontal();

          // Figure out y-axis (range).
          if (comp[optionSet.y].dataType === "number") {
            var min, max, delta, valueStep, axisStep;
            min = comp[optionSet.y].min;
            max = comp[optionSet.y].max;
            // Because values can be stacked, figure out actual stacked max.
            var stackedObj = {};
            var stackedMax = 0;
            $.each(comp[optionSet.x].vals, function (index, value) {
              if (stackedObj[value] === undefined) {
                stackedObj[value] = {};
                stackedObj[value].total = Number(comp[optionSet.y].vals[index]);
                stackedObj[value].label = value;
              } else {
                stackedObj[value].total += Number(
                  comp[optionSet.y].vals[index]
                );
              }
              var barNum = Object.keys(stackedObj[value]).length - 2;
              stackedObj[value][barNum] = {
                label: comp[optionSet.label].vals[index],
                value: Number(comp[optionSet.y].vals[index]),
                compIndex: index
              };
            });
            $.each(stackedObj, function (name, value) {
              stackedMax = stackedMax < value.total ? value.total : stackedMax;
            });
            max = stackedMax > max ? stackedMax : max;
            min = min > 0 ? 0 : min;
            delta = max - min;
            valueStep = delta / 10;
            axisStep = yAxisHeight / 10;
          }
          // Figure out x-axis.
          // Number bars (shared) will be equal to the logged rows in stackedObj
          var barWidth, bars;
          bars = Object.keys(stackedObj).length;
          barWidth = xAxisWidth / bars - barMargin;
          // Build basic axis, no data.
          var $svg = $(
            '\
            <svg \
              class="bb-p-graph-widget-stacked-bar-svg" \
              xmlns="http://www.w3.org/2000/svg" \
              data-visualizes="' +
              comp.gridIdentifier +
              '" \
              width="' +
              baseWidth +
              '" \
              height="' +
              baseHeight +
              '" \
              viewBox="0 0 ' +
              baseWidth +
              " " +
              baseHeight +
              '">\
                <defs>\
                  <filter id="glow" x="-10%" y="-10%" width="150%" height="150%">\
                    <feGaussianBlur stdDeviation="5 5" result="glow"/>\
                    <feMerge>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                    </feMerge>\
                  </filter>\
                </defs>\
            </svg>'
          )
            .append(
              '\
            <g class="break-out">\
              <a alt="maximise" xlink:href="#" aria-label="Break graph out of page">\
                <rect \
                  x="0" \
                  y="0" \
                  fill="green" \
                  width="30" \
                  height="30">\
                </rect>\
              </a>\
              <text \
                x="5" \
                y="23">\
                  <tspan class="symbol">&#10529;</tspan>\
                  <title>Maximize</title>\
              </text>\
            </g>'
            )
            .append(
              '\
            <g class="close">\
              <a alt="close" xlink:href="#" aria-label="Delete this graph">\
                <rect \
                  x="' +
                (baseWidth - 30) +
                '" \
                  y="0" \
                  fill="red" \
                  width="30" \
                  height="30">\
                </rect>\
              </a>\
              <text \
                x="' +
                (baseWidth - 21) +
                '" \
                y="21">\
                  <tspan classs="symbol">x</tspan>\
                  <title>Delete this graph</title>\
              </text>\
            </g>'
            )
            .append(
              '\
            <text \
              x="20" \
              y="' +
                baseHeight / 2 +
                '" \
              transform="rotate(-90 20 ' +
                baseHeight / 2 +
                ')"\
              class="title">\
                ' +
                this.stringParse(comp[optionSet.y].heading) +
                "\
            </text>"
            )
            .append(
              '\
            <text \
              x="' +
                baseWidth / 2 +
                '" \
              y="' +
                (baseHeight - 5) +
                '"\
              class="title">\
                ' +
                this.stringParse(comp[optionSet.x].heading) +
                "\
            </text>"
            )
            .append(
              '\
            <line \
              x1="' +
                padding.left +
                '" \
              y1="' +
                (padding.top + yAxisHeight) +
                '" \
              x2="' +
                (baseWidth - padding.right) +
                '" \
              y2="' +
                (padding.top + yAxisHeight) +
                '" \
              class="guideline">\
            </line>'
            )
            .append(
              '\
            <line \
              x1="' +
                padding.left +
                '" \
              y1="' +
                (padding.top + yAxisHeight) +
                '" \
              x2="' +
                padding.left +
                '" \
              y2="' +
                padding.top +
                '" \
              class="guideline">\
            </line>'
            );
          // Add the y-axis range and gridlines.
          var i;
          for (i = 0; i <= 10; i++) {
            $svg
              .append(
                '\
              <text \
                x="' +
                  (padding.left - 10) +
                  '" \
                y="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '" \
                text-anchor="end">\
                  ' +
                  Math.round(min + valueStep * i) +
                  "\
              </text>"
              )
              .append(
                '\
              <line \
                class="gridline" \
                x1="' +
                  (padding.left - 5) +
                  '" \
                x2="' +
                  (padding.left + xAxisWidth) +
                  '" \
                y1="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '" \
                y2="' +
                  (padding.top + yAxisHeight - i * axisStep) +
                  '">\
              </line>'
              );
          }
          // Build the stacked bars.
          $svg.append(
            '\
            <g \
              id="bars" \
              transform="scale(1,-1) translate(' +
              (padding.left + barMargin / 2) +
              ",-" +
              (yAxisHeight + baseHeight) +
              ')">\
            </g>'
          );
          if (hasLegend) {
            $svg.append(
              '\
              <g \
                id="legend">\
                  <text \
                    x="' +
                (baseWidth - 5) +
                '" \
                    y="' +
                closeButtonOffset +
                '" \
                    class="title"\
                    text-anchor="end">\
                      ' +
                this.stringParse(comp[optionSet.legend].heading) +
                "\
                  </text>\
              </g>"
            );
          }
          var barPos = 0;
          $.each(stackedObj, function (stackLabel, barObj) {
            // Go through the barObj, and build each section.
            var currentHeight = 0;
            var sectionPos;
            var barHeight = yAxisHeight * ((barObj.total - min) / delta);
            for (
              sectionPos = 0;
              sectionPos < Object.keys(barObj).length - 2;
              sectionPos++
            ) {
              var sectionValue = barObj[sectionPos].value;
              var deltaV = sectionValue - min; // Delta between min range value, and barValue
              var vRatio = deltaV / delta; // How much space does the barValue take in the total value.
              var sectionHeight = yAxisHeight * vRatio; // How much space does barValue take in terms of the axis size.
              var sectionLabel = barObj[sectionPos].label;
              var x = (barWidth + barMargin) * barPos;
              var y = padding.bottom + yAxisHeight + currentHeight;
              var legendLabel = !hasLegend
                ? false
                : comp[optionSet.legend].vals[barObj[sectionPos].compIndex];
              var color = !hasLegend
                ? "rgb(0,150,200)"
                : build.generateColor.go(legendLabel, comp.gridIdentifier);
              $svg.children("g#bars").append(
                '\
                <rect \
                  x="' +
                  x +
                  '" \
                  y="' +
                  y +
                  '" \
                  width="' +
                  barWidth +
                  '" \
                  height="' +
                  sectionHeight +
                  '" \
                  stroke="white" \
                  stroke-width="1" \
                  fill="' +
                  color +
                  '"\
                  fill-opacity=".9" \
                  highlight="true" \
                  data-identifier="' +
                  legendLabel +
                  '" \
                  class="stackedBar">\
                    <animate attributeName="height" from="0" to="' +
                  sectionHeight +
                  '" dur="1s" fill="freeze" />\
                </rect>\
                <g class="stackedLabel">\
                  <text \
                    x="' +
                  ((barWidth + barMargin) * barPos +
                    (barWidth + barMargin) / 2) +
                  '"\
                    y="' +
                  (-baseHeight + padding.top - currentHeight) +
                  '"\
                    filter="url(#glow)"\
                    style="fill:#fff;"\
                    transform="scale(1,-1) rotate(-90 ' +
                  ((barWidth + barMargin) * barPos +
                    (barWidth + barMargin) / 2) +
                  " " +
                  (-baseHeight + padding.top - currentHeight) +
                  ')"> \
                      &nbsp;&nbsp;&nbsp;' +
                  build.stringParse(sectionLabel) +
                  '&nbsp;\
                  </text>\
                  <text \
                    x="' +
                  ((barWidth + barMargin) * barPos +
                    (barWidth + barMargin) / 2) +
                  '"\
                    y="' +
                  (-baseHeight + padding.top - currentHeight) +
                  '"\
                    class="label" \
                    transform="scale(1,-1) rotate(-90 ' +
                  ((barWidth + barMargin) * barPos +
                    (barWidth + barMargin) / 2) +
                  " " +
                  (-baseHeight + padding.top - currentHeight) +
                  ')"> \
                      &nbsp;&nbsp;&nbsp;' +
                  build.stringParse(sectionLabel) +
                  "&nbsp;\
                  </text>\
                </g>"
              );
              currentHeight += sectionHeight;

              // Build the legend
              if (hasLegend) {
                var itemCount = $svg.find(
                  'g#legend [data-type="legend-item"]'
                ).length;
                if (
                  !$svg.find(
                    '[data-identifier="' +
                      legendLabel +
                      '"][data-type="legend-item"]'
                  ).length
                )
                  $svg
                    .children("g#legend")
                    .append(
                      '\
                      <rect \
                        x="' +
                        (baseWidth - textBlockSize - 5) +
                        '" \
                        y="' +
                        (itemCount +
                          closeButtonOffset +
                          itemCount * (textBlockSize + 2) +
                          5) +
                        '" \
                        width="' +
                        textBlockSize +
                        '" \
                        height="' +
                        textBlockSize +
                        '" \
                        fill="' +
                        color +
                        '" \
                        fill-opacity=".9" \
                        highlight="true" \
                        data-identifier="' +
                        legendLabel +
                        '" \
                        data-type="legend-item" \
                        stroke="none" >\
                      </rect>'
                    )
                    .append(
                      '\
                      <text \
                        x="' +
                        (baseWidth - textBlockSize - 10) +
                        '" \
                        y="' +
                        (itemCount +
                          closeButtonOffset +
                          itemCount * (textBlockSize + 2) +
                          textBlockSize) +
                        '" \
                        text-anchor="end" \
                        class="legend-item" >\
                          ' +
                        build.stringParse(legendLabel) +
                        "\
                      </text>"
                    );
              }
            }
            // Make the top total value labels.
            $svg.children("g#bars").append(
              '\
              <text \
                x="' +
                ((barWidth + barMargin) * barPos +
                  (barWidth + barMargin) / 2 -
                  5) +
                '"\
                y="' +
                (-(baseHeight + yAxisHeight) + padding.top / 2) +
                '"\
                class="label"\
                text-anchor="start"\
                transform="scale(1,-1) rotate(-30, ' +
                ((barWidth + barMargin) * barPos +
                  (barWidth + barMargin) / 2 -
                  5) +
                ", " +
                (-(baseHeight + yAxisHeight) + padding.top / 2) +
                ')"> \
                  ' +
                barObj.total +
                '\
              </text>\
              <line \
                x1="' +
                ((barWidth + barMargin) * barPos + barWidth / 2) +
                '" \
                y1="' +
                (-(baseHeight + yAxisHeight) + padding.top / 2 + 14) +
                '" \
                x2="' +
                ((barWidth + barMargin) * barPos + barWidth / 2) +
                '" \
                y2="' +
                (-(baseHeight + yAxisHeight) +
                  padding.top +
                  (yAxisHeight - barHeight)) +
                '" \
                class="gridline dotted" \
                transform="scale(1,-1)" \
                stroke-dasharray="2, 5"> \
              </line>'
            );
            // Make the bottom labels.
            $svg.children("g#bars").append(
              '\
              <text \
                x="' +
                ((barWidth + barMargin) * barPos + (barWidth + barMargin) / 2) +
                '" \
                y="' +
                (-yAxisHeight - (padding.bottom - 10)) +
                '" \
                class="label" \
                text-anchor="end" \
                transform="scale(1,-1) rotate(-30, ' +
                ((barWidth + barMargin) * barPos + (barWidth + barMargin) / 2) +
                ", " +
                (-yAxisHeight - (padding.bottom - 10)) +
                ')"> \
                  &nbsp;&nbsp;&nbsp;' +
                build.stringParse(barObj.label) +
                "&nbsp;\
              </text>"
            );
            barPos++;
          });
          // Add the SVG and refresh the whole thing to show SVGs
          var svgID =
            $widget.attr("id") +
            Math.floor(Math.random() * 100000 + 1) +
            "-svg-container";
          $widget.append(
            '<div id="' + svgID + '" class="svg-container"></div>'
          );
          var $container = $("#" + svgID);
          var $scales = $(
            '<button class="svg-scale-down">-</button><button class="svg-scale-up">+</button>'
          );
          $container.append($scales);
          $container.append($svg);
          var pos = $svg.offset().top - 50;
          $container.html($container.html());
          // Scroll the page to show the graph
          var $parentContainer = $("#bb-q");
          setTimeout(function () {
            $parentContainer.animate(
              {
                scrollTop:
                  pos -
                  $parentContainer.offset().top +
                  $parentContainer.scrollTop()
              },
              300
            );
          }, 100);
          setTimeout(function () {
            $("html, body").animate(
              {
                scrollTop: pos
              },
              300
            );
          }, 100);
        },
        pie: function (comp, $widget, optionSet) {
          // Reset Settings
          this.getReady(comp.gridIdentifier);
          var textBlockSize = 13;
          var padding = {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50
          };
          //var sliceColumn = $widget.find('.pie-chart-option select[data-slice]');
          //var labelColumn = $widget.find('.pie-chart-option select[data-label]');
          //var additional = $widget.find('.pie-chart-option div[data-additional]');
          var radius = 150;
          var slices = comp.row;
          radius = radius > slices * 10 ? radius : comp.row * 10;
          var labelMax =
            comp[optionSet.labels].maxLength >= 20
              ? 20
              : comp[optionSet.labels].maxLength;
          var minWidth =
            labelMax * textBlockSize + padding.left + radius * 2 + 50;
          var baseWidth =
            minWidth > $widget.width() ? minWidth : $widget.width();
          var baseHeight = 400;
          baseHeight =
            baseHeight > radius * 2 + padding.top + padding.bottom
              ? baseHeight
              : radius * 2 + padding.top + padding.bottom;
          var closeButtonOffset = 45;
          var legendTitleOffset = 15;
          var additionalDataTableOffset = 100;
          baseHeight =
            baseHeight >
            comp.row * (textBlockSize + 2) +
              padding.bottom +
              closeButtonOffset +
              legendTitleOffset +
              additionalDataTableOffset
              ? baseHeight
              : comp.row * (textBlockSize + 2) +
                padding.bottom +
                closeButtonOffset +
                legendTitleOffset;
          // Build the basic svg
          var $svg = $(
            '\
            <svg \
              class="bb-p-graph-widget-pie-svg" \
              xmlns="http://www.w3.org/2000/svg" \
              data-visualizes="' +
              comp.gridIdentifier +
              '" \
              width="' +
              baseWidth +
              '" \
              height="' +
              baseHeight +
              '" \
              viewBox="0 0 ' +
              baseWidth +
              " " +
              baseHeight +
              '">\
                <defs>\
                  <filter id="glow" x="-10%" y="-10%" width="150%" height="150%">\
                    <feGaussianBlur stdDeviation="5 5" result="glow"/>\
                    <feMerge>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                      <feMergeNode in="glow"/>\
                    </feMerge>\
                  </filter>\
                  <filter x="0" y="0" width="1" height="1" id="solid">\
                    <feFlood flood-color="white"/>\
                    <feComposite in="SourceGraphic"/>\
                  </filter>\
                </defs>\
            </svg>'
          )
            .append(
              '\
              <g class="break-out">\
                <a alt="maximise" xlink:href="#" aria-label="Break graph out of page">\
                  <rect \
                    x="0" \
                    y="0" \
                    fill="green" \
                    width="30" \
                    height="30">\
                  </rect>\
                </a>\
                <text \
                  x="5" \
                  y="23">\
                    <tspan class="symbol">&#10529;</tspan>\
                    <title>Maximize</title>\
                </text>\
              </g>'
            )
            .append(
              '\
              <g class="close">\
                <a alt="close" xlink:href="#" aria-label="Delete this graph">\
                  <rect \
                    x="' +
                (baseWidth - 30) +
                '" \
                    y="0" \
                    fill="red" \
                    width="30" \
                    height="30">\
                  </rect>\
                </a>\
                <text \
                  x="' +
                (baseWidth - 21) +
                '" \
                  y="21">\
                    <tspan classs="symbol">x</tspan>\
                    <title>Delete this graph</title>\
                </text>\
              </g>'
            )
            .append(
              '\
              <text \
                class="title" \
                text-anchor="end" \
                x="' +
                (baseWidth - 10) +
                '" \
                y="' +
                (padding.top + closeButtonOffset) +
                '"> \
                  ' +
                this.stringParse(comp[optionSet.labels].heading) +
                "\
              </text>\
            "
            )
            .append(
              '\
              <text \
                class="title" \
                text-anchor="end" \
                x="' +
                baseWidth / 2 +
                '" \
                y="' +
                (baseHeight - 10) +
                '"> \
                  ' +
                this.stringParse(comp[optionSet.slices].heading) +
                "\
              </text>\
            "
            );
          // Loop through the rows to build slices
          var total = comp[optionSet.slices].total;
          var start = { x: 0, y: radius * -1 };
          var vertex = 0;
          var processed = {
            doing: "",
            done: []
          };
          $.each(comp[optionSet.labels].vals, function (k, v) {
            if (processed.done.indexOf(v) === -1) {
              processed.done.push(v);
              processed.doing = v;
              var i;
              for (i = 0; i < slices; i++) {
                var sliceLabel = comp[optionSet.labels].vals[i];
                if (sliceLabel !== processed.doing) {
                  continue;
                } else {
                  var sliceColor = build.generateColor.go(
                    sliceLabel,
                    comp.gridIdentifier
                  );
                  var value = comp[optionSet.slices].vals[i];
                  var additionalData = {};

                  // Add additional data to be given to each slice (in the legend).
                  additionalData[comp[optionSet.slices].heading] = value;
                  additionalData[comp[optionSet.labels].heading] = sliceLabel;

                  $.each(optionSet.additional, function (k, v) {
                    var heading = comp[v].heading;
                    var val = comp[v].vals[i];
                    additionalData[heading] = val;
                  });

                  // Calculate slice as isosceles triangle
                  vertex += (value / total) * 360;
                  var largeArcFlag = vertex > 180 ? 1 : 0;
                  if (vertex > 359) {
                    $svg.prepend(
                      '\
                    <g \
                      transform="translate(' +
                        (radius + padding.left) +
                        "," +
                        baseHeight / 2 +
                        ")\" \
                      data-additional=' " +
                        JSON.stringify(additionalData) +
                        ' \' \
                      class="pie-slice" \
                      data-for="' +
                        sliceLabel +
                        '" \
                      data-slice-id="' +
                        vertex +
                        '">\
                      <circle \
                        r="' +
                        radius +
                        '" \
                        fill="' +
                        sliceColor +
                        '" \
                        stroke="white" \
                        strokeWidth="1"> \
                    </g>\
                    '
                    );
                  } else {
                    var baseLength = 0;
                    var end = { x: 0, y: 0 };
                    var arcRad = radius;
                    var baseAngle = 0;
                    var controlAngle = 0;
                    var yAdd = 0;
                    var xAdd = 0;

                    baseLength =
                      2 * Math.sin(((vertex / 2) * Math.PI) / 180) * radius;
                    baseAngle = (180 - vertex) / 2;
                    controlAngle = 90 - baseAngle;
                    yAdd =
                      baseLength * Math.sin((controlAngle * Math.PI) / 180);
                    xAdd =
                      baseLength * Math.cos((controlAngle * Math.PI) / 180);

                    end.x = Number(start.x) + xAdd;
                    end.y = Number(start.y) + yAdd;

                    var d =
                      "M 0,0 l " +
                      start.x +
                      " " +
                      start.y +
                      " A " +
                      arcRad +
                      " " +
                      arcRad +
                      " 0 " +
                      largeArcFlag +
                      " 1 " +
                      end.x +
                      " " +
                      end.y +
                      " Z";
                    $svg.prepend(
                      '\
                    <g \
                      transform="translate(' +
                        (radius + padding.left) +
                        "," +
                        baseHeight / 2 +
                        ")\" \
                      data-additional=' " +
                        JSON.stringify(additionalData) +
                        ' \' \
                      class="pie-slice" \
                      data-for="' +
                        sliceLabel +
                        '" \
                      data-slice-id="' +
                        vertex +
                        '" >\
                      <path \
                        fill="' +
                        sliceColor +
                        '" \
                        stroke="white" \
                        d="' +
                        d +
                        '" />\
                    </g>\
                    '
                    );
                  }

                  // Now add the respective legend item.
                  if (
                    !$svg.find(
                      '[data-type="legend-data"][data-for="' + sliceLabel + '"]'
                    ).length
                  ) {
                    var itemCount = $svg.find(
                      '[data-type="legend-data"]'
                    ).length;
                    $svg.append(
                      '\
                    <g \
                      class="pie-slice" \
                      data-type="legend-data" \
                      data-for="' +
                        sliceLabel +
                        '" \
                      data-slice-id="' +
                        vertex +
                        '">\
                      <text \
                        x="' +
                        (baseWidth - textBlockSize - 10) +
                        '" \
                        y="' +
                        (closeButtonOffset +
                          itemCount * (textBlockSize + 2) +
                          padding.top +
                          legendTitleOffset +
                          textBlockSize) +
                        '" \
                        text-anchor="end" \
                        class="legend-item" >\
                          ' +
                        build.stringParse(sliceLabel) +
                        '\
                      </text> \
                      <rect \
                        x="' +
                        (baseWidth - (textBlockSize + 5)) +
                        '" \
                        y="' +
                        (closeButtonOffset +
                          itemCount * (textBlockSize + 2) +
                          padding.top +
                          legendTitleOffset) +
                        '" \
                        width="' +
                        textBlockSize +
                        '" \
                        height="' +
                        textBlockSize +
                        '" \
                        fill="' +
                        sliceColor +
                        '" \
                        fill-opacity="1" \
                        stroke="none" \
                      </rect>\
                    </g>'
                    );
                  } else {
                    $svg
                      .find(
                        '[data-type="legend-data"][data-for="' +
                          sliceLabel +
                          '"]'
                      )
                      .attr("data-slice-id", "multi");
                  }
                }
              }
            }
          });

          var svgID =
            $widget.attr("id") +
            Math.floor(Math.random() * 100000 + 1) +
            "-svg-container";
          $widget.append(
            '<div id="' + svgID + '" class="svg-container"></div>'
          );
          var $container = $("#" + svgID);
          var $scales = $(
            '<button class="svg-scale-down">-</button><button class="svg-scale-up">+</button>'
          );
          $container.append($scales);
          $container.append($svg);
          var pos = $svg.offset().top - 50;
          $container.html($container.html());
          // Scroll the page to show the graph
          var $parentContainer = $("#bb-q");
          setTimeout(function () {
            $parentContainer.animate(
              {
                scrollTop:
                  pos -
                  $parentContainer.offset().top +
                  $parentContainer.scrollTop()
              },
              300
            );
          }, 100);
          setTimeout(function () {
            $("html, body").animate(
              {
                scrollTop: pos
              },
              300
            );
          }, 100);
        },
        getReady: function (identifier) {
          this.generateColor.settings.currentColor = 0;
          (this.generateColor.settings.overrides =
            userDefined &&
            directives[identifier] &&
            directives[identifier].colorOverrides
              ? directives[identifier].colorOverrides
              : false),
            (this.currentGraph = identifier);
          this.generateColor.colorArray =
            userDefined &&
            directives[identifier] &&
            directives[identifier].colorArray
              ? directives[identifier].colorArray
              : [
                  "hsl(0,50%,60%)",
                  "hsl(20,50%,60%)",
                  "hsl(40,50%,60%)",
                  "hsl(60,50%,60%)",
                  "hsl(80,50%,60%)",
                  "hsl(100,50%,60%)",
                  "hsl(120,50%,60%)",
                  "hsl(140,50%,60%)",
                  "hsl(160,50%,60%)",
                  "hsl(180,50%,60%)",
                  "hsl(200,50%,60%)",
                  "hsl(220,50%,60%)",
                  "hsl(240,50%,60%)",
                  "hsl(260,50%,60%)",
                  "hsl(280,50%,60%)",
                  "hsl(300,50%,60%)",
                  "hsl(320,50%,60%)",
                  "hsl(340,50%,60%)"
                ];
        },
        generateColor: {
          settings: {
            currentColor: 0,
            overrides: false
          },
          go: function (str) {
            if (this.settings.overrides[str] !== undefined) {
              return this.settings.overrides[str];
            } else {
              if (
                userDefined &&
                directives[build.currentGraph] &&
                directives[build.currentGraph].useGenerator === "true"
              ) {
                return this.toHSL(str);
              } else {
                if (colorMap[str] === undefined) {
                  colorMap[str] = this.colorArray[this.settings.currentColor];
                  if (this.settings.currentColor < this.colorArray.length - 1) {
                    this.settings.currentColor += 1;
                  } else {
                    this.settings.currentColor = 0;
                  }
                }
                return colorMap[str];
              }
            }
          },
          colorArray: [],
          toHSL: function (str) {
            str = String(str);
            var n = this.toNumber(str);
            var h;
            h = this.inRange(n);
            return "hsl(" + h + ",50%,60%)";
          },
          toNumber: function (str) {
            var n = 0;
            var ii;
            for (ii = 0; ii < str.length; ii++) {
              n += String(str.charAt(ii).charCodeAt());
            }
            return Number(n);
          },
          inRange: function (nR) {
            while (nR >= 360) {
              if (nR > 999999999) {
                nR = Math.sqrt(nR);
              } else {
                nR = nR / 3.6;
              }
            }
            return Math.round(nR);
          }
        },
        stringParse: function (str) {
          str = String(str);
          return str.length > 20
            ? str.substr(0, 10) + "..." + str.substr(-7)
            : str;
        }
      };

      // Process the grids:
      $.each(data.groups, function (groupIndex, groupObject) {
        $.each(groupObject.controls, function (controlIndex, controlObject) {
          if (
            controlObject.controltype === "grid" &&
            !controlObject.addallowed &&
            controlObject.showasgraph
          ) {
            var flag = false;
            // Let's prepare a comparison object to help decide how best to visualize.
            var comp = {
              gridIdentifier: controlObject.identifier,
              string: 0,
              number: 0,
              column: 0,
              row: 0
            };
            $.each(controlObject.columns, function (k, v) {
              if (
                v.controltype === "label" ||
                v.controltype === "linklabel" ||
                v.readonly
              ) {
                comp.column += 1;
                comp[k] = {};
                comp[k].heading = v.colname;
              } else {
                flag = true;
              }
            });
            if (flag) return true;
            $.each(controlObject.value, function (index, row) {
              comp.row += 1;
              // Loop through each row, cell by cell.
              var i;
              for (i = 0; i < comp.column; i++) {
                var type;
                // First check what type of data this cell is.
                type =
                  Number(row[i].value) !== Number(row[i].value)
                    ? "string"
                    : "number";
                if (comp[i].dataType) {
                  if (type !== "number" && comp[i].dataType !== "string") {
                    comp[i].dataType = type;
                  }
                } else {
                  comp[i].dataType = type;
                  comp[type] += 1;
                }
                // Now we know the data type, we can evaluate ranges.
                if (type === "number") {
                  comp[i].total = comp[i].total || 0;
                  comp[i].vals = comp[i].vals || [];
                  comp[i].repeatedCount = comp[i].repeatedCount || 0;
                  if (comp[i].vals.indexOf(Number(row[i].value)) > -1) {
                    comp[i].repeatedCount += 1;
                  }
                  // Get the max value:
                  if (
                    comp[i].max === undefined ||
                    Number(row[i].value) > comp[i].max
                  ) {
                    comp[i].max = Number(row[i].value);
                  }
                  // Log the max string length
                  if (
                    comp[i].maxLength === undefined ||
                    String(row[i].value).length > comp[i].maxLength
                  ) {
                    comp[i].maxLength = String(row[i].value).length;
                  }
                  // Get min value
                  if (
                    comp[i].min === undefined ||
                    Number(row[i].value) < comp[i].min
                  ) {
                    comp[i].min = Number(row[i].value);
                  }
                  comp[i].vals.push(Number(row[i].value));
                  comp[i].total += Number(row[i].value);
                }
                if (type === "string") {
                  // Let's figure our how many times it's repeated.
                  comp[i].vals = comp[i].vals || [];
                  comp[i].repeatedCount = comp[i].repeatedCount || 0;
                  if (comp[i].vals.indexOf(row[i].value) > -1) {
                    comp[i].repeatedCount += 1;
                  }
                  // Log the max string length
                  if (
                    comp[i].maxLength === undefined ||
                    row[i].value.length > comp[i].maxLength
                  ) {
                    comp[i].maxLength = row[i].value.length;
                  }
                  comp[i].vals.push(row[i].value);
                }
              }
            });
            // Now we have a comparison object.
            /*
              Since the number of columns, rows and data types vary so much,
              let's build a widget for the user to select which columns to
              use to build the graphs.
              Unless there are specific instructions (per grid)
              to say what chart to build, and using which columns.
            */
            if (
              userDefined &&
              directives[comp.gridIdentifier] &&
              directives[comp.gridIdentifier].force
            ) {
              try {
                var force = directives[comp.gridIdentifier].force;
                $(
                  '<div id="bb-p-graph-widget-for' +
                    controlObject.id +
                    '" class="bb-p-graph-widget-container soft"></div>'
                ).insertAfter('[id="' + controlObject.id + '"]');
                var $widget = $("#bb-p-graph-widget-for" + controlObject.id);
                var propMap = {};
                var optionSet = {};
                $.each(comp, function (k, v) {
                  if (typeof v === "object") {
                    propMap[v.heading] = k;
                  }
                });
                if (force.graphType === "column") {
                  optionSet = {
                    width: $widget.width(),
                    y: propMap[force.yAxis],
                    x: propMap[force.xAxis],
                    legend: propMap[force.legend]
                  };
                  build.bar(comp, $widget, optionSet);
                }
                if (force.graphType === "stackedBar") {
                  optionSet = {
                    width: $widget.width(),
                    y: propMap[force.yAxis],
                    x: propMap[force.xAxis],
                    legend: propMap[force.legend],
                    label: propMap[force.label]
                  };
                  build.stackedBar(comp, $widget, optionSet);
                }
                if (force.graphType === "pie") {
                  var additionalArr = [];
                  $.each(force.additional, function (k) {
                    additionalArr.push(propMap[force.additional[k]]);
                  });
                  optionSet = {
                    width: $widget.width(),
                    slices: propMap[force.values],
                    labels: propMap[force.labels],
                    additional: additionalArr
                  };
                  build.pie(comp, $widget, optionSet);
                }
              } catch (e) {
                window.console &&
                  window.console.warn(
                    "Charts could't be rendered - possibly incorrect column labels provided in server instructions."
                  );
              }
            } else {
              var yOptions = function (comp, flag) {
                var returnVals = "";
                $.each(comp, function (k, v) {
                  if (v.dataType && v.dataType === "number") {
                    if (flag === "no-negatives" && v.min >= 0) {
                      returnVals +=
                        '<option data-column="' +
                        k +
                        '">' +
                        v.heading +
                        "</option>";
                    } else if (flag === "no-negatives" && v.min < 0) {
                      returnVals +=
                        '<option data-column="' +
                        k +
                        '" disabled>' +
                        v.heading +
                        "</option>";
                    } else if (flag === "no-flag") {
                      returnVals +=
                        '<option data-column="' +
                        k +
                        '">' +
                        v.heading +
                        "</option>";
                    }
                  }
                });
                return returnVals;
              };
              var xOptions = function (comp) {
                var returnVals = "";
                $.each(comp, function (k, v) {
                  if (v.dataType) {
                    returnVals +=
                      '<option data-column="' +
                      k +
                      '">' +
                      v.heading +
                      "</option>";
                  }
                });
                return returnVals;
              };
              var xOptionsCHKL = function (comp) {
                var returnVals = "";
                $.each(comp, function (k, v) {
                  if (v.dataType) {
                    returnVals +=
                      '<span data-for="' +
                      k +
                      '" class="additional-pie-data"><label for="' +
                      k +
                      '"><input id="' +
                      k +
                      '" type="checkbox" />' +
                      v.heading +
                      "</label></span>";
                  }
                });
                return returnVals;
              };

              $(
                '<div id="bb-p-graph-widget-for' +
                  controlObject.id +
                  '" class="bb-p-graph-widget-container"></div>'
              ).insertAfter('[id="' + controlObject.id + '"]');
              $widget = $("#bb-p-graph-widget-for" + controlObject.id);
              $widget
                .append("<h3>Visualize This Data</h3>")
                .append(
                  '<div class="bb-p-graph-widget-option-set"><nav role="tablist" class="bb-p-graph-widget-option-set-tabs-nav"></nav></div>'
                );
              $widget
                .children(".bb-p-graph-widget-option-set")
                .children(".bb-p-graph-widget-option-set-tabs-nav ")
                .append(
                  '\
                 <button class="bb-p-graph-widget-tab" role="tab" aria-selected="false" data-for="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-column-option">\
                   <span>Column Chart<span>\
                   <div><img src="plugins/grids-to-graphs/live/column-chart-icon.svg?reload1" /></div>\
                 </button>'
                )

                .append(
                  '\
                 <button class="bb-p-graph-widget-tab" role="tab" aria-selected="false" data-for="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-pie-option">\
                   <span>Pie Chart<span>\
                   <div><img src="plugins/grids-to-graphs/live/pie-chart-icon.svg" /></div>\
                 </button>'
                )

                .append(
                  '\
                 <button class="bb-p-graph-widget-tab" role="tab" aria-selected="false" data-for="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-stacked-option">\
                   <span>Stacked Columns</span>\
                   <div><img src="plugins/grids-to-graphs/live/stacked-column-chart-icon.svg?reload1" /></div>\
                 </button>'
                );

              // Column graph option set:

              $widget
                .children(".bb-p-graph-widget-option-set")
                .append(
                  '\
                  <div \
                    id="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-column-option" \
                    class="visual-option column-chart-option" \
                    role="tabpanel" \
                    aria-label="Visualize the data as a column-chart">\
                  </div>'
                )
                .children(".column-chart-option")
                .append(
                  '<table class="bb-p-graph-widget-option-set-table">' +
                    "<tr>" +
                    "<td>" +
                    "<label>" +
                    "I want to see each " +
                    "<select data-x>" +
                    xOptions(comp) +
                    "</select>" +
                    "as an individual column. (Each table row will respresent 1 column)" +
                    "</label>" +
                    "<label>" +
                    "Comparing them based on " +
                    "<select data-y>" +
                    yOptions(comp, "no-flag") +
                    "</select>" +
                    "as a range." +
                    "</label>" +
                    "</td>" +
                    '<td class="extra-options">' +
                    "<label>Bar colors: " +
                    "<select data-legend >" +
                    '<option data-column="none">none</option>' +
                    xOptions(comp) +
                    "</select>" +
                    "</label>" +
                    "</td>" +
                    "</tr>" +
                    "</table>"
                )
                .append('<button class="visualize">Visualize</button>')
                .children("button.visualize")
                .on("click", function () {
                  build.bar(comp, $widget, build.getOptions($widget, "column"));
                });

              // Pie graph option set:

              $widget
                .children(".bb-p-graph-widget-option-set")
                .append(
                  '\
                 <div \
                   id="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-pie-option"\
                   class="visual-option pie-chart-option" \
                   role="tabpanel" \
                   aria-label="Visualize the data as a pie-chart">\
                 </div>'
                )
                .children(".pie-chart-option")
                .append(
                  '<table class="bb-p-graph-widget-option-set-table">' +
                    "<tr>" +
                    "<td>" +
                    "<label>" +
                    "I want to make a slice (or set of slices) for each " +
                    "<select data-label>" +
                    xOptions(comp) +
                    "</select>" +
                    "where each slice represents a proportionate value of " +
                    "<select data-slice>" +
                    yOptions(comp, "no-negatives") +
                    "</select>" +
                    "in a pie." +
                    "</label>" +
                    "</td>" +
                    '<td class="extra-options">' +
                    "<label>Additional Slice Data: </label>" +
                    "<div data-additional>" +
                    xOptionsCHKL(comp) +
                    "</div>" +
                    "</td>" +
                    "</tr>" +
                    "</table>"
                )
                .append('<button class="visualize">Visualize</button>')
                .children("button.visualize")
                .on("click", function () {
                  build.pie(comp, $widget, build.getOptions($widget, "pie"));
                });
              setTimeout(function () {
                pieOptionAdjust();
              }, 1000);

              // Stacked graph option set:

              $widget
                .children(".bb-p-graph-widget-option-set")
                .append(
                  '\
                  <div \
                    id="bb-p-graph-widget-for' +
                    controlObject.id +
                    '-stacked-option" \
                    class="visual-option stacked-chart-option" \
                    role="tabpanel" \
                    aria-label="Visualize the data as a stacked column chart">\
                  </div>'
                )
                .children(".stacked-chart-option")
                .append(
                  '<table class="bb-p-graph-widget-option-set-table">' +
                    "<tr>" +
                    "<td>" +
                    "<label>" +
                    "I want to see each " +
                    "<select data-x>" +
                    xOptions(comp) +
                    "</select>" +
                    "as a column." +
                    "</label>" +
                    "<label>" +
                    "Comparing the columns based on " +
                    "<select data-y>" +
                    yOptions(comp, "no-negatives") +
                    "</select>" +
                    "as a range." +
                    "</label>" +
                    "</td>" +
                    '<td class="extra-options">' +
                    "<label>Bar colors: " +
                    "<select data-legend >" +
                    '<option data-column="none">none</option>' +
                    xOptions(comp) +
                    "</select>" +
                    "</label>" +
                    "<label>Bars labels: " +
                    "<select data-label >" +
                    xOptions(comp) +
                    "</select>" +
                    "</label>" +
                    "</td>" +
                    "</tr>" +
                    "</table>"
                )
                .append('<button class="visualize">Visualize</button>')
                .children("button.visualize")
                .on("click", function () {
                  build.stackedBar(
                    comp,
                    $widget,
                    build.getOptions($widget, "stackedBar")
                  );
                });
            }
          }
        });
      });
    }
  });
  // Handlers.
  // For the tabs:
  $(doc).on("click", ".bb-p-graph-widget-tab", function (e) {
    var $button = $(e.target).data("for")
      ? $(e.target)
      : $(e.target).parents("button");
    var $tab = $("#" + $button.data("for"));
    var $container = $("#bb-q");
    var pos = $button.offset().top - 50;
    setTimeout(function () {
      $container.animate(
        {
          scrollTop: pos - $container.offset().top + $container.scrollTop()
        },
        300
      );
    }, 100);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: pos
        },
        300
      );
    }, 100);
    $button
      .parent()
      .children('[role="tab"]')
      .removeClass("showing")
      .attr("aria-selected", "false");
    $button.addClass("showing").attr("aria-selected", "true");
    $tab.parent().children('[role="tabpanel"]').removeClass("tab-selected");
    $tab.addClass("tab-selected");
  });
  // For the scale controls:
  $(doc).on("click", ".svg-scale-up, .svg-scale-down", function (e) {
    var $svg = $(e.target).nextAll("svg");
    var control = e.target.className;
    var current = {
      width: Number($svg.attr("width")),
      height: Number($svg.attr("height"))
    };
    var step = 1.2;
    if (control === "svg-scale-up") {
      var newDims = {
        width: current.width * step,
        height: current.height * step
      };
    }
    if (control === "svg-scale-down") {
      newDims = {
        width: current.width / step,
        height: current.height / step
      };
    }
    $svg.attr("width", newDims.width);
    $svg.attr("height", newDims.height);
  });
  // For the graph close buttons:
  $(doc).on("click", ".close", function (e) {
    var pos =
      $(e.target).parents(".bb-p-graph-widget-container").offset().top - 50;
    try {
      $(e.target).parents(".svg-container").removeClass("broken-out");
      $(e.target)
        .parents(".svg-container")
        .children("svg")
        .children("g.break-in")
        .attr("class", "break-out")
        .children("text")
        .html(
          '\
          <tspan class="symbol">&#10529;</tspan>\
          <title>Maximize</title>'
        );
    } catch (e) {
      window.console && console.warn(e);
    }
    setTimeout(function () {
      $(e.target).parents(".svg-container").remove();
    }, 50);
    var $container = $("#bb-q");
    setTimeout(function () {
      $container.animate(
        {
          scrollTop: pos - $container.offset().top + $container.scrollTop()
        },
        300
      );
    }, 100);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: pos
        },
        300
      );
    }, 100);
  });
  // For the graph breakout buttons:
  $(doc).on("click", ".break-out", function (e) {
    var pos = $(e.target).offset().top - 50;
    $(e.target).parents("svg").data("scale", "2");
    $(e.target).parents(".svg-container").addClass("broken-out");
    $(e.target)
      .parents(".svg-container")
      .attr("data-pos", pos)
      .children("svg")
      .children("g.break-out")
      .attr("class", "break-in")
      .children("text")
      .html(
        '\
        <tspan class="symbol">&#10533;</tspan>\
        <title>Minimize</title>'
      );
  });
  $(doc).on("click", ".break-in", function (e) {
    var pos = $(e.target).parents(".svg-container").data("pos");
    $(e.target).parents("svg").data("scale", "1");
    $(e.target).parents(".svg-container").removeClass("broken-out");
    $(e.target)
      .parents(".svg-container")
      .children("svg")
      .children("g.break-in")
      .attr("class", "break-out")
      .children("text")
      .html(
        '\
        <tspan class="symbol">&#10529;</tspan>\
        <title>Maximize</title>'
      );
    var $container = $("#bb-q");
    setTimeout(function () {
      $container.animate(
        {
          scrollTop: pos - $container.offset().top + $container.scrollTop()
        },
        300
      );
    }, 100);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: pos
        },
        300
      );
    }, 100);
  });
  // Trigger scaling and drag scroll for broken-out charts
  $(doc).on("DOMMouseScroll mousewheel", ".broken-out", function (e) {
    e.stopPropagation();
    var relativeButtons = {
      $up: $(e.target).parents(".broken-out").find(".svg-scale-up"),
      $down: $(e.target).parents(".broken-out").find(".svg-scale-down")
    };
    if (
      typeof e.originalEvent.detail == "number" &&
      e.originalEvent.detail !== 0
    ) {
      if (e.originalEvent.detail > 0) {
        relativeButtons.$down.trigger("click");
      } else if (e.originalEvent.detail < 0) {
        relativeButtons.$up.trigger("click");
      }
    } else if (typeof e.originalEvent.wheelDelta == "number") {
      if (e.originalEvent.wheelDelta < 0) {
        relativeButtons.$down.trigger("click");
      } else if (e.originalEvent.wheelDelta > 0) {
        relativeButtons.$up.trigger("click");
      }
    }
  });
  $.dragScroll = (function (options) {
    var settings = $.extend(
      {
        scrollVertical: true,
        scrollHorizontal: true,
        cursor: null
      },
      options
    );

    var clicked = false,
      clickY,
      clickX;

    var getCursor = function () {
      if (settings.cursor) return settings.cursor;
      if (settings.scrollVertical && settings.scrollHorizontal) return "move";
      if (settings.scrollVertical) return "row-resize";
      if (settings.scrollHorizontal) return "col-resize";
    };

    var updateScrollPos = function (e, el) {
      $("html").css("cursor", getCursor());
      var $el = $(el);
      settings.scrollVertical &&
        $el.scrollTop($el.scrollTop() + (clickY - e.pageY));
      clickY = e.pageY;
      settings.scrollHorizontal &&
        $el.scrollLeft($el.scrollLeft() + (clickX - e.pageX));
      clickX = e.pageX;
    };
    $(doc).on("mousemove", ".broken-out", function (e) {
      clicked && updateScrollPos(e, this);
    });
    $(doc).on("mousedown", ".broken-out", function (e) {
      clicked = true;
      clickY = e.pageY;
      clickX = e.pageX;
    });
    $(doc).on("mouseup", ".broken-out", function () {
      clicked = false;
      $("html").css("cursor", "auto");
    });
  })();
  // For the pie options
  var pieOptionAdjust = function () {
    $(".pie-chart-option").each(function () {
      var parent = $(this);
      parent.find("span.additional-pie-data").show();
      var currentLabelCol = parent
        .find("select[data-label]")
        .find(":selected")
        .attr("data-column");
      var currentSliceCol = parent
        .find("select[data-slice]")
        .find(":selected")
        .attr("data-column");
      parent
        .find('[data-additional] span[data-for="' + currentLabelCol + '"]')
        .hide()
        .find('input[type="checkbox"]')
        .prop("checked", false);
      parent
        .find('[data-additional] span[data-for="' + currentSliceCol + '"]')
        .hide()
        .find('input[type="checkbox"]')
        .prop("checked", false);
      // Count the checked checkboxes and disable the unchecked if there are 4 checked.
      var checkedTot = parent.find(
        '.extra-options input[type="checkbox"]:checked'
      ).length;
      if (checkedTot >= 4) {
        parent
          .find('.extra-options input[type="checkbox"]:not(":checked")')
          .prop("disabled", true);
        flasher(
          "Max. additional options reached",
          parent.find("span.additional-pie-data")
        );
      } else {
        parent
          .find('.extra-options input[type="checkbox"]:not(":checked")')
          .prop("disabled", false);
      }
    });
  };
  $(doc).on(
    "change",
    ".pie-chart-option select[data-label], .pie-chart-option select[data-slice], .pie-chart-option .extra-options",
    function () {
      pieOptionAdjust();
    }
  );
  // For the pie slices
  $(doc).on("mouseover", ".pie-slice", function (e) {
    var containerID = $(e.target).parents(".svg-container").attr("id");
    var sliceValue =
      $(e.target).attr("class") === "pie-slice"
        ? $(e.target).data("for")
        : $(e.target).parents(".pie-slice").data("for");
    var sliceID =
      $(e.target).attr("class") === "pie-slice"
        ? $(e.target).data("slice-id")
        : $(e.target).parents(".pie-slice").data("slice-id");
    $("#" + containerID + " .pie-slice").attr(
      "class",
      "pie-slice slice-not-selected"
    );
    $(
      "#" +
        containerID +
        ' [data-for="' +
        sliceValue +
        '"][data-type="legend-data"]'
    ).attr("class", "pie-slice");
    $("#" + containerID + " .pie-slice-data").remove();
    if (sliceID !== "multi") {
      $("#" + containerID + ' [data-slice-id="' + sliceID + '"]').attr(
        "class",
        "pie-slice"
      );
      var additionalData = JSON.parse(
        $("#" + containerID + '  [data-slice-id="' + sliceID + '"]').data(
          "additional"
        )
      );
      $(".slice-extra-data-table").remove();
      $(".slice-extra-data-table-clipboard").remove();
      var $sliceDataTable = $('<div class="slice-extra-data-table"></div>');
      var $sliceDataTableClip = $(
        '<textarea class="slice-extra-data-table-clipboard" />'
      );
      $.each(additionalData, function (k, v) {
        $sliceDataTable.append(
          "\
          <div>\
            <span>" +
            k +
            " : </span>\
            <span>" +
            v +
            "</span>\
          </div>\
        "
        );
        $sliceDataTableClip.val(
          $sliceDataTableClip.val() + k + " : " + v + " \n\r"
        );
      });
      $(e.target).parents(".svg-container").append($sliceDataTable);
      $(e.target).parents(".svg-container").append($sliceDataTableClip);
    } else {
      $("#" + containerID + ' [data-for="' + sliceValue + '"]').attr(
        "class",
        "pie-slice"
      );
    }
  });
  $(doc).on("click", ".pie-slice", function (e) {
    var copyTextarea = $(this)
      .parents(".svg-container")
      .find(".slice-extra-data-table-clipboard");
    copyTextarea.select();
    try {
      var successful = document.execCommand("copy");
      var msg = successful
        ? "Slice data copied to clipboard."
        : "Could not copy to clipboard";
      flasher(msg, $(e.target).parents(".svg-container"));
    } catch (err) {
      flasher("Could not copy to clipboard.");
    }
  });
  // For the stacked bars
  $(doc).on(
    "mouseover",
    "\
    svg.bb-p-graph-widget-stacked-bar-svg [highlight], \
    svg.bb-p-graph-widget-bar-svg [highlight]\
    ",
    function (e) {
      var containerID = $(e.target).parents(".svg-container").attr("id");
      var identifier = $(e.target).attr("data-identifier");
      $("#" + containerID + " [highlight]").attr("highlight", "false");
      $('[data-identifier="' + identifier + '"]').attr("highlight", "true");
    }
  );
  // Resets
  $(doc).on("mouseleave", "svg :not(.sliceDataTable)", function () {
    $(".slice-not-selected").attr("class", "pie-slice");
    $(".slice-extra-data-table").remove();
    $(".slice-extra-data-table-clipboard").remove();
    $(
      "\
      svg.bb-p-graph-widget-stacked-bar-svg [highlight], \
      svg.bb-p-graph-widget-bar-svg [highlight]\
    "
    ).attr("highlight", "true");
  });
  // Simple message flasher
  var flasher = function (msg, target) {
    // Clear old flashers out.
    $(".flasher").remove();
    // Flash new message:
    var $target = target || $("body");
    var $flash = $('<div class="flasher"></div>');
    $flash.append("<span>" + msg + "</span>");
    $target.append($flash);
    setTimeout(function () {
      $(".flasher").fadeOut();
    }, 800);
  };
})(jQuery, window, document);
